import { z } from 'zod';
// ============================================
// Reports — öğrenci bazlı detay rapor (drill-down)
// ============================================
// Tek öğrencinin ödev / sınav / yaprak-test / devamsızlık kırılımı tek yerde.
// (Agregat listeler reports.service'te inline tipli; bu yalnız detay raporu.)
export const StudentDetailReportSchema = z.object({
    student: z.object({
        userId: z.string().uuid(),
        name: z.string().nullable(),
        email: z.string().nullable(),
    }),
    homeworks: z.object({
        total: z.number().int().nonnegative(),
        graded: z.number().int().nonnegative(),
        avgPoints: z.number().nullable(),
        items: z.array(z.object({
            title: z.string(),
            status: z.string(),
            earnedPoints: z.number().nullable(),
            submittedAt: z.string().datetime().nullable(),
        })),
    }),
    exams: z.object({
        total: z.number().int().nonnegative(),
        avgPercent: z.number().nullable(),
        items: z.array(z.object({
            title: z.string(),
            score: z.number().nullable(),
            totalPoints: z.number().nullable(),
            percent: z.number().nullable(),
            submittedAt: z.string().datetime().nullable(),
        })),
    }),
    worksheets: z.object({
        total: z.number().int().nonnegative(),
        totalCorrect: z.number().int().nonnegative(),
        totalWrong: z.number().int().nonnegative(),
        totalBlank: z.number().int().nonnegative(),
        items: z.array(z.object({
            title: z.string(),
            correct: z.number().nullable(),
            wrong: z.number().nullable(),
            blank: z.number().nullable(),
            durationSec: z.number().nullable(),
        })),
    }),
    attendance: z.object({
        present: z.number().int().nonnegative(),
        absent: z.number().int().nonnegative(),
        late: z.number().int().nonnegative(),
        excused: z.number().int().nonnegative(),
        total: z.number().int().nonnegative(),
    }),
});
//# sourceMappingURL=report.js.map